<template>
  <div>
    <q-card>
      <div class="titleIndicador row">
        <div class="divNameIndic col-lg-auto col-md-auto col-sm-12 col-xs-12">{{ dataIndicador.name }}</div>
        <!-- Imagen del AUE -->
        <div class="col-lg-auto col-md-auto col-sm-2 col-xs-2">
          <q-img
            v-for="objectAUE in arrayAUE"
            :key="objectAUE.img"
            :src="objectAUE.img"
            :alt="objectAUE.img"
          >
            <q-tooltip anchor="bottom middle" :offset="[0, 10]">
              <strong>{{objectAUE.prefix}}: {{objectAUE.name}} <br></strong>
              <strong v-if="objectAUE.nameEspecifico">{{objectAUE.prefixEspecifico}}:  {{objectAUE.nameEspecifico}}</strong>
            </q-tooltip>
          </q-img>
          <!-- Imagen del objetivo -->
          <q-img
            v-for="objectODS in arrayODS"
            :key="objectODS.img"
            :src="objectODS.img"
            :alt="objectODS.img"
          >
          <q-tooltip anchor="bottom middle" :offset="[0, 10]">
            <strong>{{objectODS.name}}</strong>
          </q-tooltip>
        </q-img>
        </div>
        <!--chips indices tematicos-->
        <div class="col-lg-auto col-md-auto col-sm-10 col-xs-10">
          <q-chip outline v-for="imgIndice in imgIndicesTematicos" :key="imgIndice.img">
            <q-avatar >
              <img  :src="imgIndice.img ? imgIndice.img : require(`@/assets/${imgDefault}`)" alt="indice temático">
            </q-avatar>
          {{imgIndice.name}}
        </q-chip>
        </div>

      </div>
    </q-card>
  </div>
</template>

<script>
import Message from '@/components/shared/mixins/Message.js';
import Loading from '@/components/shared/mixins/Loading.js';
import Resources from '@/components/shared/mixins/Resources.js';
import { QImg, QAvatar } from 'quasar';
import Const from '@/components/shared/helpers/Const.js';

export default {
  components: {
    QImg,
    QAvatar
  },
  mixins: [Message, Resources, Loading],
  props: {
    dataIndicador: Object,
    imgDefault: {
      type: String,
      default: function () {
        return 'img/iconfinder-icon-image.jpg';
      }
    }
  },
  data () {
    return {
      arrayODS: [],
      arrayAUE: [],
      imgIndicesTematicos: []
    };
  },
  created () {
    this.refillData();
  },
  watch: {
    dataIndicador () {
      this.refillData();
    }
  },
  methods: {
    refillData () {
      this.imgIndicesTematicos = [];
      this.arrayODS = [];
      this.arrayAUE = [];
      this.fillODSorAUE();
      if (this.dataIndicador.hasOwnProperty('indicesTematicos')) this.fillIndicesTematicos();
    },
    fillODSorAUE () {
      if (this.dataIndicador.hasOwnProperty('objetivos')) {
        this.dataIndicador.objetivos.forEach(objetivo => {
          // diferenciar si es de aue o si es de ods
          if (objetivo.idIndice === Const.ID_ODS) {
            this.arrayODS.push({ img: this.searchResource(objetivo.file, 'imagen').url, name: objetivo.name });
          } else {
            this.fillArrayAue(objetivo);
          }
        });
      }
      if (this.dataIndicador.hasOwnProperty('objetivo')) {
        this.fillArrayAue(this.dataIndicador.objetivo);
      }
    },
    fillArrayAue (objetivo) {
      let positionSpaceName;
      let nameEspecificoWithOutNumber;
      if (this.dataIndicador.hasOwnProperty('objetivoEspecifico')) {
        positionSpaceName = this.dataIndicador.objetivoEspecifico.name.indexOf(' ');
        nameEspecificoWithOutNumber = this.dataIndicador.objetivoEspecifico.name.substring(positionSpaceName);
      }
      this.arrayAUE.push({
        img: this.searchResource(objetivo.file, 'imagen').url,
        name: objetivo.name,
        prefix: objetivo.prefix,
        nameEspecifico: this.dataIndicador.hasOwnProperty('objetivoEspecifico') ? nameEspecificoWithOutNumber : '',
        prefixEspecifico: this.dataIndicador.hasOwnProperty('objetivoEspecifico') ? this.dataIndicador.objetivoEspecifico.prefix : ''
      });
    },
    fillIndicesTematicos () {
      this.dataIndicador.indicesTematicos.forEach(indiceTematico => {
        if (indiceTematico && indiceTematico.file && indiceTematico.file.length > 0) {
          this.imgIndicesTematicos.push({ img: this.searchResource(indiceTematico.file, 'imagen').url, name: indiceTematico.name });
        } else {
          this.imgIndicesTematicos.push({ name: indiceTematico.name });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.titleIndicador {
  font-family: DINPro;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 0.29px;
  color: #002f6c;
  .divNameIndic {
    margin-right: 25px;
    align-items: center;
    display: flex;
  }
  display: flex;
}

.q-img{
  width: 40px;
  margin-right: 15px;
}

.q-chip--outline {
  padding: 15px;
  border: solid 1px #979797 !important;
}
.q-avatar{
  height: 25px;
  width: 25px;
}
@media (max-width: 640px) {
  ::v-deep {
    .q-img {
      height: 25px;
      width: 25px;
    }
    .q-avatar {
      height: 25px;
      width: 25px;
    }
    .q-chip__content {
      font-size: 11px;
    }
    .divNameIndic{
      padding: 0px 0px 10px 0px;
    }
  }
}

</style>
